import { unAuthorizedToken } from '../utils/Validations'
import { getAuthToken } from './authHelper';
const server_address = process.env.REACT_APP_SERVER_ADDRESS;

export const vendorOnboardRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/onboard`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`,
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const updateVendorRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/update`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const updateRejectedRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/vendor/update/rejected`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const updateApprovedRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/vendor/update`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getStatesAndCities = () => {
  return fetch(`${server_address}/api/v1/util/get/states-and-cities`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const approveRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/approve`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const approveCeFRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/approve-l1`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const approveDeletingVendor = (body) => {
  return fetch(`${server_address}/api/v1/vendors/vendor/delete`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const approveDeactivatingVendor = (body) => {
  return fetch(`${server_address}/api/v1/vendors/vendor/deactivate`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const approveActivatingVendor = (body) => {
  return fetch(`${server_address}/api/v1/vendors/vendor/activate`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

//this one we are looking for
export const approveUpdatingVendor = (body) => {
  return fetch(`${server_address}/api/v1/vendors/vendor/update`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const rejectRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/reject`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getUpdatedRequestDetails = (body) => {
  return fetch(`${server_address}/api/v1/vendors/get/vendor/detail`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getPendingVendors = () => {
  let selected_city = localStorage.getItem('selected_city')?`&city=${localStorage.getItem('selected_city')}`:''
  return fetch(`${server_address}/api/v1/vendors/pending?offset=0&limit=100` + selected_city, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const deletePendingVendors = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/delete`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getApprovedVendors = () => {
  let selected_city = localStorage.getItem('selected_city')?`&city=${localStorage.getItem('selected_city')}`:''
  return fetch(`${server_address}/api/v1/vendors/approved?offset=0&limit=20` + selected_city, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const sendDeleteRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/vendor/delete`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const sendDeactivateRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/vendor/deactivate`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const sendActivateRequest = (body) => {
  return fetch(`${server_address}/api/v1/vendors/request/vendor/activate`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const validateGSTN = (gstn) => {
  return fetch(`${server_address}/api/v1/vendors/validate?gstn=${gstn}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const validateBankDetails = (body) => {
  return fetch(`${server_address}/api/v1/vendors/bankdetailsvalidate`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: JSON.stringify(body),
    method: 'POST'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const editBufRejectedVendor = (body) => {
  return fetch(`${server_address}/api/v1/vendors/editBufRejectedVendor`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const rejectBufRejectedVendor = (body) => {
  return fetch(`${server_address}/api/v1/vendors/rejectBufRejectedVendor`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: body,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const bulkUpdateVendors = (payload) => {
  return fetch(`${server_address}/api/v1/vendors/vendor/upload`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    body: payload,
    method: 'POST'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}

export const getTdsSection = () => {
  return fetch(`${server_address}/api/v1/vendors/get/tds-sections`, {
    headers: new Headers({
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
     if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
};

export const checkVendorActivePayments = (vendor_buffer_id) => {
  return fetch(`${server_address}/api/v1/vendors/checkActivePayments/${vendor_buffer_id}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {                                                                                                          
      return res.json()
    }
  })
}

export const validatePancard = (pancard) => {
  return fetch(`${server_address}/api/v1/vendors/validatePancard?pancard=${pancard}`, {
    headers: new Headers({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${getAuthToken()}`
    }),
    method: 'GET'
  }).then((res) => {
    if (res.status === 401) {
      unAuthorizedToken()
    }
    else {
      return res.json()
    }
  })
}


// WEBPACK FOOTER //
// ./src/utils/VendorApiUtils.js